import { MessageCircle } from "lucide-react";
import { WHATSAPP_LINK } from "../brand";

export const FloatingWhatsApp = () => {
  return (
    <a
      href={WHATSAPP_LINK}
      target="_blank"
      rel="noreferrer"
      data-testid="floating-whatsapp-btn"
      aria-label="Chat with ooloo on WhatsApp"
      className="fixed bottom-6 left-6 z-50 bg-[#25d366] text-white p-4 rounded-full shadow-[0_12px_36px_-8px_rgba(37,211,102,0.55)] hover:scale-110 transition-transform flex items-center justify-center"
    >
      <MessageCircle size={26} strokeWidth={2.4} fill="#ffffff" />
      <span className="sr-only">WhatsApp</span>
    </a>
  );
};
